// Harici bileşen bağımlılığını kaldırdık, her şey self-contained çalışsın diye.
// React Icons yerine inline SVG kullanarak build hatalarını engelliyoruz.

import hiImage from '../assets/images/hi.png';

const Icons = {
  Heart: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  ),
  Star: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Smile: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
  ),
  Users: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Rocket: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
    </svg>
  )
};

export const About = () => {
  return (
    <div className="min-h-screen bg-[#FDFDFC] relative overflow-hidden">
      {/* Arka Plan Dekorasyonları (Startup/Modern His) */}
      <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-orange-50 to-transparent pointer-events-none" />
      <div className="absolute top-20 right-[-50px] w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-40 pointer-events-none" />
      <div className="absolute bottom-20 left-[-50px] w-80 h-80 bg-yellow-100 rounded-full blur-3xl opacity-40 pointer-events-none" />

      <div className="container mx-auto px-4 py-16 relative z-10">

        {/* --- HEADER BÖLÜMÜ --- */}
        <div className="max-w-6xl mx-auto mb-20">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

            {/* Sol Taraf - Metin */}
            <div className="text-center lg:text-left space-y-6">
              <div className="inline-block px-4 py-1.5 bg-orange-100 text-orange-700 rounded-full text-sm font-bold tracking-wide shadow-sm border border-orange-200">
                HİKAYEMİZ & DEĞERLERİMİZ
              </div>
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 tracking-tight leading-tight">
                Merhaba, Biz <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500">Mucittin</span> Ekibiyiz! <span className="inline-block animate-bounce">👋</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 font-medium leading-relaxed">
                Küçük mucitlerin hayal güçlerini gerçeğe dönüştürmek için buradayız.
                Bilimi oyunla, eğitimi eğlenceyle birleştiriyoruz.
              </p>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start pt-4">
                <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-xl font-bold text-sm">#MerakEt</span>
                <span className="px-4 py-2 bg-purple-50 text-purple-700 rounded-xl font-bold text-sm">#Keşfet</span>
                <span className="px-4 py-2 bg-green-50 text-green-700 rounded-xl font-bold text-sm">#Tasarla</span>
              </div>
            </div>

            {/* Sağ Taraf - Görsel */}
            <div className="relative group">
              <div className="absolute inset-4 bg-gradient-to-tr from-orange-400 to-pink-400 rounded-[2.5rem] blur-2xl opacity-30 group-hover:opacity-50 transition-opacity duration-500" />
              <img
                src={hiImage}
                alt="Mucittin Ekibi - Merhaba!"
                className="relative w-full rounded-[2.5rem] shadow-2xl border-4 border-white transform transition-transform duration-500 group-hover:rotate-1 group-hover:scale-[1.02]"
                onError={(e) => {
                  e.currentTarget.src = "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80";
                }}
              />

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 animate-bounce" style={{ animationDuration: '3s' }}>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                    <Icons.Heart className="w-6 h-6" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-bold uppercase">Topluluk</p>
                    <p className="text-lg font-black text-gray-900">10k+ Mucit</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* --- ANA STORY KARTI (Glassmorphism & Bento Style) --- */}
        <div className="max-w-5xl mx-auto mb-20">
          <div className="bg-white rounded-[2.5rem] shadow-xl shadow-orange-100/50 border border-gray-100 p-8 md:p-12 relative overflow-hidden group hover:shadow-2xl hover:shadow-orange-200/50 transition-all duration-500">
            {/* Dekoratif Arka Plan Deseni */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-orange-50 to-transparent rounded-bl-[100%] opacity-50" />

            <div className="relative z-10 flex flex-col md:flex-row items-center gap-10 text-center md:text-left">
              <div className="flex-1 space-y-6">
                <div className="text-6xl mb-4 transform group-hover:scale-110 transition-transform duration-300 inline-block">🚀</div>
                <h2 className="text-3xl font-bold text-gray-800">
                  Öğrenmeyi <span className="text-orange-500 decoration-wavy underline decoration-orange-300">Süper Güç</span> Haline Getiriyoruz
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Mucittin, sadece bir çizgi film veya web sitesi değil; burası meraklı zihinlerin buluşma noktası.
                  Sıkıcı dersleri bir kenara bırakıp, deneyerek, yanılarak ve kahkaha atarak öğrenmenin peşindeyiz.
                </p>
                <div className="flex flex-wrap gap-3 justify-center md:justify-start">
                  <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-xl font-bold text-sm">#MerakEt</span>
                  <span className="px-4 py-2 bg-purple-50 text-purple-700 rounded-xl font-bold text-sm">#Keşfet</span>
                  <span className="px-4 py-2 bg-green-50 text-green-700 rounded-xl font-bold text-sm">#Tasarla</span>
                </div>
              </div>

              {/* Sağ Taraf - İstatistik veya Görsel Alanı */}
              <div className="w-full md:w-1/3 bg-gray-50 rounded-3xl p-6 border-2 border-dashed border-gray-200 flex flex-col items-center justify-center min-h-[200px]">
                <span className="text-5xl font-black text-gray-800 mb-2">10k+</span>
                <span className="text-gray-500 font-semibold">Küçük Mucit</span>
                <div className="mt-4 flex -space-x-2 overflow-hidden">
                  {/* Avatar Placeholderları */}
                  {[1, 2, 3, 4].map(i => (
                    <div key={i} className={`w-10 h-10 rounded-full border-2 border-white bg-gradient-to-br ${i % 2 === 0 ? 'from-blue-200 to-blue-400' : 'from-pink-200 to-pink-400'}`}></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- DEĞERLER GRID (Bento Grid Layout) --- */}
        <div className="max-w-6xl mx-auto mb-20">
          <div className="text-center mb-10">
            <h3 className="text-3xl font-bold text-gray-800">Bizi Özel Kılan Şeyler ✨</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Card 1 */}
            <div className="bg-red-50 rounded-3xl p-8 border border-red-100 hover:-translate-y-2 transition-transform duration-300 group">
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-red-500 shadow-sm mb-6 group-hover:rotate-12 transition-transform">
                <Icons.Heart className="w-8 h-8" />
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-3">Sevgiyle Öğren</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Hata yapmaktan korkma. Biz her denemeyi, her çabayı alkışlıyoruz. Sabır bizim süper gücümüz.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-purple-50 rounded-3xl p-8 border border-purple-100 hover:-translate-y-2 transition-transform duration-300 group">
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-purple-500 shadow-sm mb-6 group-hover:rotate-12 transition-transform">
                <Icons.Star className="w-8 h-8" />
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-3">Sen Özelsin!</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Her çocuğun hızı ve tarzı farklıdır. Kendi ritminde, kendi renginde parlaman için buradayız.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-orange-50 rounded-3xl p-8 border border-orange-100 hover:-translate-y-2 transition-transform duration-300 group">
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-orange-500 shadow-sm mb-6 group-hover:rotate-12 transition-transform">
                <Icons.Smile className="w-8 h-8" />
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-3">Sınırsız Eğlence</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Sıkıcı derslere yer yok! Oyunlar, hikayeler ve kahkahalarla dolu bir macera seni bekliyor.
              </p>
            </div>

            {/* Card 4 */}
            <div className="bg-blue-50 rounded-3xl p-8 border border-blue-100 hover:-translate-y-2 transition-transform duration-300 group">
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center text-blue-500 shadow-sm mb-6 group-hover:rotate-12 transition-transform">
                <Icons.Users className="w-8 h-8" />
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-3">Takım Oyunu</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Mucittin ailesinde herkes birbirine destek olur. Birlikte daha güçlüyüz, birlikte daha zekiyiz.
              </p>
            </div>
          </div>
        </div>

        {/* --- MİSYON CTA (Modern Banner) --- */}
        <div className="max-w-5xl mx-auto">
          <div className="bg-gray-900 rounded-[3rem] p-10 md:p-16 text-center relative overflow-hidden">
            {/* Arka Plan Efektleri */}
            <div className="absolute top-0 right-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-orange-500 rounded-full blur-[100px] opacity-30"></div>
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-blue-500 rounded-full blur-[100px] opacity-30"></div>

            <div className="relative z-10">
              <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-8 text-white">
                <Icons.Rocket className="w-8 h-8" />
              </div>
              <h2 className="text-3xl md:text-5xl font-black text-white mb-6">
                Hedefimiz Çok Net 🎯
              </h2>
              <p className="text-lg md:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-10">
                Dünyanın her yerindeki çocukların içindeki o <span className="text-white font-bold">yaratıcı ışığı</span> yakmak ve onlara geleceği inşa etmeleri için ilham vermek.
              </p>
              <button className="bg-white text-gray-900 hover:bg-orange-400 hover:text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg transform hover:scale-105 active:scale-95">
                Bize Katılın
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};